import { useGoalById } from 'features/goals';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { PageSectionBase } from 'shared/components/ui/page-section-base';
import { Paths } from 'shared/routes';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

import { CompletedTasksList } from '../completed-tasks-list';
import { SubItemsList } from '../sub-items-list';
import { Interactions } from './interactions';
import * as Styled from './sub-items-section.style';

export type SubItemsSectionProps = {
  fullSize?: boolean;
  grow?: boolean;
  hasLink?: boolean;
};

export const SubItemsSection: React.FC<SubItemsSectionProps> = ({
  fullSize,
  grow,
  hasLink,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const goal = useGoalById(id);

  const progressUrl = useMemo(
    () => replaceUrlParams(Paths.GoalDetailTasks, { id: id! }),
    [id],
  );

  if (!goal) {
    return null;
  }

  return (
    <PageSectionBase
      title={t('pages.goal-detail.tasks.title')}
      url={hasLink ? progressUrl : undefined}
      fullSize={fullSize}
      grow={grow}
      interactions={<Interactions />}
      noPadding
    >
      <Styled.ScrollContainer $scrollAuto={!!fullSize}>
        <SubItemsList goal={goal} />
        <CompletedTasksList goal={goal} />
      </Styled.ScrollContainer>
    </PageSectionBase>
  );
};
